module.exports = __webpack_public_path__ + "img/banner.dcd9069c.png";